import React from "react";
import { SlidePages } from "../../components/slidePages";
import { Interventions } from "../../components/serviceDetails/intervention";
import { AGIcon } from "../../assets/icons/AGIcon";
import { DPEIcon } from "../../assets/icons/DPEIcon";
import { PlanificationIcon } from "../../assets/icons/PlanificationIcon";
import { Realisation } from "../../components/home/realisation";
import { DemandeDevis } from "../../components/home/demandeDevis";
import { Prestations } from "../../components/home/prestations";
import { ServiceCards } from "../../components/serviceDetails/serviceCards";
import fa1 from "../../assets/images/fa1.png";
import fa2 from "../../assets/images/fa2.png";
import fa3 from "../../assets/images/fa3.png";
import rea1 from "../../assets/images/rea33.png";
import rea2 from "../../assets/images/rea22.png";
import rea3 from "../../assets/images/rea23.png";
import rea4 from "../../assets/images/rea24.png";
import rea5 from "../../assets/images/rea25.png";
import rea6 from "../../assets/images/rea26.png";
export const FacadePage = () => {
  const prestations = [
    {
      icon: fa1,
      text: "Ravalement à la chaux : respirant et esthétique",
    },
    {
      icon: fa2,
      text: "Traitement anti-fissures",
    },
    {
      icon: fa3,
      text: "Enduits et finitions personnalisées",
    },
  ];
  const items = [
    {
      icon: <AGIcon />,
      text: "Gestion des AG",
    },
    {
      icon: <DPEIcon />,
      text: "DPE collectif",
    },
    {
      icon: <PlanificationIcon />,
      text: "Planification",
    },
  ];
  const realisations = [
    {
      image: rea1,
      text: "Ravalement de façade",
      link: "/ravalement-façade",
    },
    {
      image: rea2,
      text: "Ravalement de façade",
      link: "/ravalement-façade",
    },
    {
      image: rea3,
      text: "Ravalement de façade",
      link: "/ravalement-façade",
    },
    {
      image: rea4,
      text: "Ravalement de façade",
      link: "/ravalement-façade",
    },
    {
      image: rea5,
      text: "Ravalement de façade",
      link: "/ravalement-façade",
    },
    {
      image: rea6,
      text: "Ravalement de façade",
      link: "/ravalement-façade",
    },
  ];
  return (
    <div>
      {" "}
      <SlidePages
        title={"Ravalement de façade"}
        description={
          "Un ravalement est indispensable pour protéger les murs, embellir le bâti et prévenir les infiltrations."
        }
      />
      <Interventions
        title={"Types de ravalement"}
        description={
          "Chaque façade a sa solution : découvrez nos techniques selon vos besoins."
        }
        prestations={prestations}
      />
      <ServiceCards
        items={items}
        title={"Spécial copropriétés"}
        description={
          "Esthétique, performance et sérénité pour tous les copropriétaires."
        }
      />
      <Realisation realisations={realisations} />
      <DemandeDevis title={"Recevez un devis façade personnalisé"} />
      <Prestations
        title={"D’autres services"}
        description={
          "Des solutions durables pour un habitat plus beau, plus sain et moins énergivore."
        }
      />
    </div>
  );
};
